import {ValidatorFn, ValidationErrors, AbstractControl} from '@angular/forms';

export const allFieldsEmpty: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
  const values = Object.values(formGroup.value);
  let hasEmptyFields = false;
  let empty = 0;
  values.forEach(value => {
    if (value instanceof Array) {
      if (value.length === 0) {
      } else if (value.length === 1) {
        if (value[0] instanceof Object) {
          const vals = Object.values(value[0]).filter(val => val !== '' && val !== null && val !== undefined);
          if (vals && vals.length === 0) {
            empty++;
          }
        } else if (!value[0]) {
          empty++;
        }
      } else {
        const vals = Object.values(value[0]).filter(val => val !== '' && val !== null && val !== undefined);
        if (vals && vals.length === 0) {
          empty++;
        }
      }
    }
  });

  hasEmptyFields = values.length === empty;
  return hasEmptyFields ? {allFieldsRequired: true} : null;
};
